var _defs, _circle, _path, _path2, _circle2, _circle3, _circle4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTreats(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 9,
    x2: 55,
    y1: 7,
    y2: 57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCE7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBCFE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bone",
    x1: 12,
    x2: 52,
    y1: 20,
    y2: 44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE8B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F59E0B"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 29,
    fill: "url(#bg)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bone)",
    d: "M18 24a7 7 0 0 1 12-5l4 4 4-4a7 7 0 1 1 7 12l-4 4 4 4a7 7 0 1 1-7 7l-4-4-4 4a7 7 0 1 1-12-5l4-4-4-4a7 7 0 0 1 0-9Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F97316",
    d: "M24 34h16v5H24z",
    opacity: 0.65
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 3,
    fill: "#FB7185"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 18,
    r: 2.5,
    fill: "#F472B6"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 49,
    r: 3,
    fill: "#FB7185"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreats);
export default __webpack_public_path__ + "static/media/treats.d97f4089e0b2b2763ec1a4c9a4f88aeb.svg";
export { ForwardRef as ReactComponent };